import React, { useState } from "react";
import { XIcon } from "@heroicons/react/solid";

/**
 * Chip-style tag input. `value` is an array of strings; `onChange` receives
 * the new array. Add with Enter or comma, remove with the chip's × or
 * Backspace on an empty input.
 */
function TagInput({ value = [], onChange, placeholder }) {
  const [input, setInput] = useState("");

  const add = (raw) => {
    const tag = raw.trim().replace(/,$/, "");
    if (tag && !value.includes(tag)) onChange([...value, tag]);
    setInput("");
  };

  const remove = (tag) => onChange(value.filter((t) => t !== tag));

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      add(input);
    } else if (e.key === "Backspace" && !input && value.length) {
      remove(value[value.length - 1]);
    }
  };

  return (
    <div className="mt-1 flex flex-wrap items-center gap-2 rounded-lg border border-gray-300 p-2 shadow-sm transition focus-within:border-fairblue-500 focus-within:ring-2 focus-within:ring-fairblue-500">
      {value.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center gap-1 rounded-full bg-fairblue-100 py-1 pl-3 pr-1.5 text-sm font-medium text-fairblue-700"
        >
          {tag}
          <button
            type="button"
            onClick={() => remove(tag)}
            aria-label={`Remove ${tag}`}
            className="rounded-full p-0.5 text-fairblue-500 hover:bg-fairblue-200 hover:text-fairblue-900"
          >
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" />
          </button>
        </span>
      ))}
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => add(input)}
        placeholder={value.length === 0 ? placeholder : ""}
        className="min-w-[8rem] flex-1 border-0 p-1 text-sm focus:outline-none focus:ring-0"
      />
    </div>
  );
}

export default TagInput;
